import styled, { CSSObject } from 'styled-components';

const styles: CSSObject = {
  textAlign: 'center',
  color: '#757575',
  width: '100%',
};

export const EmptyView = styled.div((props) => ({
  ...styles,
  ...props.style,
}));

export default EmptyView;
